import "./DiscountForm.scss";

import React from "react";
import { Link, Redirect } from "react-router-dom";

import request from "request"
import usesFeatures from "usesFeatures"

import Header from "Header"

import Form from "Form"
import Input from "Input"
import Select from "Select"
import Switch from "Switch"
import Textarea from "Textarea"
import CurrencyInput from "CurrencyInput"

class DiscountForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
    const discountId = this.props.computedMatch.params.discountId
    if (discountId) {
      this.props.fetchData(`venue_admin/discounts/${discountId}/edit`, this.seedForm)
    } else {
      this.props.fetchData("venue_admin/discounts/new", this.seedForm)
    }
  }

  headerText = () => this.props.formData.id ? "Edit Discount" : "New Discount"

  seedForm = (data) => {

    this.props.seedFormData(data)
   // this.setState({modifierGroups: data.formData.modifierGroups || [{name: "", modifiers: []}]})
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let discount = this.props.formData

    const discountId = this.props.formData.id
    const method = discountId ? "patch" : "post"
    const url = discountId ? `discounts/${discountId}` : "discounts"

    if(!discountId && ! discount.discountUnit) {
      discount.discountUnit = 'percent'
    }

    let req = request[method](`venue_admin/${url}`, { discount })
    req.then(({data}) => {
      if (data.success) {
        this.setState({saved: true, id: data.discount.id})
      }
    })
  }

  render() {
    if (!this.props.dataFetched) return false
    if (this.state.saved && this.state.id) return <Redirect to={`/discounts/${this.state.id}`} />

    const { updateField, formData } = this.props

    return(
      <div className="discountForm">
        <Header
          text="discounts"
          backLink={`/discounts${formData.id ? ("/" + formData.id) : ""}` }
        />
        <Form
          onSubmit={this.handleSubmit}
          title={this.headerText()}
        >
          <Input label="Discount Name" onChange={updateField.bind(null, "name")} value={formData.name} />
          <Input label="Discount Code" onChange={updateField.bind(null, "code")} value={formData.code} />

          <Input
            label="Amount"
            onChange={updateField.bind(null, "discountAmount")}
            value={formData.discountAmount}
            allowNegativeValue={false}
          />

          <Select
            label="Discount Unit"
            options={{'percent': 'percent','dollar': 'dollar'}}
            onChange={updateField.bind(null, "discountUnit")}
            value={formData.discountUnit}
           />


          <div className="block field is-grouped mt-4">
            <p className="control">
              <button onClick={this.handleSubmit} className="button is-primary">{ formData.id ? "Update" : "Create"} Discount</button>
            </p>
            <p className="control">
              <Link to={ formData.id ? `/discounts/${formData.id}` : "/discounts"} className="button">Cancel</Link>
            </p>
          </div>
        </Form>
      </div>
    )
  }
}

export default usesFeatures(['form', 'data'], DiscountForm)
